// ============================================================================
// shared/ui/Select.tsx — Select controlado por react-hook-form (reemplaza .form-select).
// forwardRef para preservar el spread {...register("campo")} (§B.3).
// ============================================================================
import { forwardRef } from "react";
import type { SelectHTMLAttributes } from "react";

type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className = "", children, ...rest }, ref) => (
    <select
      ref={ref}
      className={`tw-block tw-w-full tw-rounded tw-border tw-border-gray-300 tw-bg-white tw-px-2 tw-py-1 tw-text-sm focus:tw-outline-none focus:tw-border-primario focus:tw-ring-1 focus:tw-ring-primario ${className}`}
      {...rest}
    >
      {children}
    </select>
  ),
);
Select.displayName = "Select";
